export function isNull(val) {
    if (val === undefined || val === null || val === '') {
        return true;
    }
    return false;
}

export function isNotNull(val) {
    if (val !== undefined && val !== null && val !== '') {
        return true;
    }
    return false;
}

export function recursiveMerge(obj1, obj2) {
    for (const [key, value] of Object.entries(obj2)) {
        if (Object.prototype.toString.call(value) === '[object Object]' && value !== null) {
            obj1[key] = obj1[key] ? {...obj1[key]} : {};
            recursiveMerge(obj1[key], value);
        } else {
            obj1[key] = value;
        }
    }
    return obj1;
}

export function sleep(ms, cb) {
    return new Promise(resolve => {
        setTimeout(() => {
            if (cb) cb();
            resolve();
        }, ms)
    });
}

export async function loadMiddlewares(to, from, next, router, store) {
    if ((!to.query.tab || !store.state.ui.pageView.tabs.length) && to.meta.tab) {
        to.query.tab = new Date().getTime().toString();

        const tab = {
            name: to.name,
            path: to.path,
            fullPath: to.fullPath,
            meta: { ...to.meta },
            params: { ...to.params },
            query: { ...to.query }
        };

        if (!tab.meta.title) {
            const parts = to.path.split('/');
            let title = parts[parts.length-1];
            tab.meta.title = title.charAt(0).toUpperCase() + title.slice(1);
        };

        delete tab.meta.middleware;
        
        store.commit('ui/NEW_TAB', tab);
    }

    if (!to.meta.middleware || (to.meta.middleware && !to.meta.middleware.length)) {
        return next();
    }
    
    const middleware = Array.isArray(to.meta.middleware) ? to.meta.middleware : [to.meta.middleware];
    const context = { from, to, next, router, store };
    const nextMiddleware = nextFactory(context, middleware, 1);
    return middleware[0]({ ...context, next: nextMiddleware });
}

function nextFactory(context, middleware, index) {
    const subsequentMiddleware = middleware[index];
    
    if(!subsequentMiddleware){
        return context.next;
    }

    return (...parameters) => {
        context.next(...parameters);
        const nextMiddleware = nextFactory(context, middleware, index + 1);
        subsequentMiddleware({ ...context, next: nextMiddleware });
    };
}

export default {
    isNull,
    isNotNull,
    recursiveMerge,
    sleep,
    loadMiddlewares,
}
